/**
 * The on-screen keyboard let go of when what's under a field is dragged (a list scrolling on its own, inside the page:
 * the page's own scrolling doesn't move, so the system's "drag down to dismiss" never starts). As a search screen
 * does on a phone: the field keeps what's typed, and the list scrolls freely.
 */

/** How far a finger moves before it's a drag, not a tap (px). */
const DRAG_PX = 10;

/** Handlers for what scrolls under a field: a drag on it lets go of the field (and so of the keyboard). */
export function dismissOnDrag() {
  let from: number | null = null;
  return {
    onTouchStart: (e: TouchEvent) => {
      from = e.touches[0]?.clientY ?? null;
    },
    onTouchMove: (e: TouchEvent) => {
      const y = e.touches[0]?.clientY;
      if (from === null || y === undefined || Math.abs(y - from) < DRAG_PX) {
        return;
      }
      from = null;
      const field = document.activeElement;
      if (field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement) {
        field.blur();
      }
    },
  };
}
